// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ceda0a34","796":"8cc73c2d"}[chunkId] + ".chunk.js";
};